<template>
  <div>
    <admin-travel-service-item-edit />
  </div>
</template>

<script>
import AdminTravelServiceItemEdit from "../../../components/TravelService/Admin/AdminTravelServiceItemEdit";

export default {
  name: "AdminTravelServiceItemEditView",
  components: {
    AdminTravelServiceItemEdit
  }
};
</script>
